export default __webpack_public_path__ + "static/media/sentiment-negative.c2555931.svg";